(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const listeners = new AbortController();
    const index = root.querySelector('[data-search-index]');
    const items = [...root.querySelectorAll('[data-search-item]')];
    const status = root.querySelector('[data-search-status]');
    const results = root.querySelector('[data-search-results]');
    const pages = root.querySelector('[data-search-pages]');
    const copy = JSON.parse(root.querySelector('[data-search-copy]').textContent);
    if (!index || index.dataset.complete !== 'true' || items.length !== Number(index.dataset.expectedCount)) {
      results.replaceChildren();
      pages.replaceChildren();
      status.textContent = '';
      root.querySelector('[data-search-unavailable]').hidden = false;
      root.dataset.searchState = 'SEARCH_CONFIG_REQUIRED';
      return;
    }
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    const render = () => {
      const url = new URL(location.href);
      const query = url.searchParams.get('q') || '';
      root.querySelector('[name="q"]').value = query;
      const tokens = normalize(query).split(' ').filter(Boolean);
      const matched = tokens.length ? items.filter(item => tokens.every(token => normalize(item.dataset.text).includes(token))) : [];
      const pageCount = Math.ceil(matched.length / 12);
      const page = Math.min(Math.max(1, Number.parseInt(url.searchParams.get('result_page'), 10) || 1), Math.max(1, pageCount));
      status.textContent = !tokens.length ? copy.prompt : matched.length ? matched.length + ' ' + copy.results : copy.empty;
      results.replaceChildren(...matched.slice((page - 1) * 12, page * 12).map(item => item.content.cloneNode(true)));
      pages.replaceChildren();
      const link = (label, number) => {
        const target = new URL(location.href);
        target.searchParams.set('q', query);
        target.searchParams.set('result_page', number);
        target.searchParams.delete('page');
        const node = document.createElement('a');
        node.href = target.pathname + target.search;
        node.textContent = label;
        pages.append(node);
      };
      if (page > 1) link(copy.previous, page - 1);
      if (pageCount > 1) {
        const current = document.createElement('span');
        current.textContent = page + ' / ' + pageCount;
        current.setAttribute('aria-current', 'page');
        pages.append(current);
      }
      if (page < pageCount) link(copy.next, page + 1);
    };
    root.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(location.href);
      url.searchParams.set('q', root.querySelector('[name="q"]').value);
      url.searchParams.delete('result_page');
      url.searchParams.delete('page');
      history.pushState(null, '', url);
      render();
    }, {signal:listeners.signal});
    window.addEventListener('popstate', render, {signal:listeners.signal});
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      listeners.abort();
      delete root.dataset.initialized;
    }, {signal:listeners.signal});
    render();
  };
  const start = () => document.querySelectorAll('[data-mojis-search]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
